import { useI18n } from "@/context/I18nContext";
import { Globe } from "lucide-react";

export default function LanguageSwitcher({ variant = "light" }) {
  const { lang, setLang, langs } = useI18n();
  const dark = variant === "dark";
  return (
    <div className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 border ${dark ? "border-white/25 bg-white/10 text-white" : "border-gray-200 bg-white text-gray-700"}`}>
      <Globe className="h-3.5 w-3.5 opacity-70" />
      <select
        data-testid="language-switcher"
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        className={`bg-transparent outline-none text-xs font-medium pr-4 cursor-pointer ${dark ? "text-white" : "text-gray-800"}`}
      >
        {Object.values(langs).map((l) => (
          <option key={l.code} value={l.code} className="text-gray-900">{l.native}</option>
        ))}
      </select>
    </div>
  );
}
